<template>
  <FloatButton
    v-bind="$attrs"
    :style="{ top: '1rem', right: '1rem' }"
    :hidden="hiddenRef"
    modal
  >
    <template #icon>
      <Logo style="width: 100px; padding: 4px" />
    </template>
    <template #menu>
      <div class="-menuitems">
        <RouterLink class="-menuitem fx_outline" :to="{ name: ROUTE_HOME }">
          <LogoType />
        </RouterLink>
        <RouterLink
          class="-menuitem fx_outline"
          :to="{ name: ROUTE_AFFORDABLE_HOUSING }"
        >
          Affordable Housing
          <!-- , Community Development + Public Finance -->
        </RouterLink>
        <a class="-menuitem fx_outline" :href="`#${ID_CONTACT}`">
          Contact HB+D</a
        >
        <RouterLink
          class="-menuitem fx_outline"
          :to="{ name: ROUTE_DISCLAIMER }"
        >
          Disclaimer
        </RouterLink>
      </div>
    </template>
  </FloatButton>
</template>

<style scoped lang="scss">
.-menuitems {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  white-space: nowrap;

  position: absolute;
  top: calc(100% + 1rem);
  right: 0;
  text-align: end;
}
.-menuitem {
  padding: 1rem;
}
</style>

<script setup>
import FloatButton from "../components/FloatButton.vue";
import LogoType from "../components/LogoType.vue";
import {
  ROUTE_DISCLAIMER,
  ROUTE_AFFORDABLE_HOUSING,
  ROUTE_HOME,
} from "../routing";
import { ID_CONTACT } from "../variables.js";
import Logo from "./Logo.vue";

//////////

import { ref, onMounted, onUnmounted } from "vue";
const hiddenRef = ref(false);

let lastScroll = 0;
function showHideNavBar() {
  const scroll = document.documentElement.scrollTop;
  hiddenRef.value = scroll > lastScroll;
  lastScroll = scroll;
}

onMounted(() => {
  document.addEventListener("scroll", showHideNavBar);
});

onUnmounted(() => {
  document.removeEventListener("scroll", showHideNavBar);
});

//////////
</script>
